import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'app/profile/services/user.service';

import {NavService} from 'shared/nav/nav.service';
import { DefaultMenuPage } from '../default-menu-page/default-menu-page';

@Component({
  selector: 'personal-page',
  templateUrl: 'personal-page.html',
  styleUrls: ['personal-page.scss'],
})
export class PersonalPage extends DefaultMenuPage implements OnInit {

  public lineY = '';

  public episodesOnly = false;

  constructor(
    public navService: NavService,
    private userService: UserService,
    private translateService: TranslateService,
  ) {
    super(navService, translateService);
    if ( navService.get('lineY') !== undefined ) {
      this.lineY = (navService.get('lineY')-56-24)+'px'; // TODO: Header-Höhe und halbe Itemhöhe
      // console.log("## "+navService.get('lineY')+'px');
    }
    console.log("## "+this.userService.getCompanyEpisodesCached());
    this.episodesOnly = this.userService.getCompanyEpisodesCached() == 2;
  }

  public get newBadgeCount(): number {
    return this.userService.getNewBadgeCount();
  }

  public ngOnInit(): void {
  }

  public showThesesPage(type: string): void {
    this.navService.push('/theses', {start: type});
  }

  public showMonitoringPage(): void {
    this.navService.push('/insights/monitoring');
  }
  
  public showContentCerfificates(): void {
    this.navService.push('/content/certificates');
  }

  public showBadgesPage(): void {
    this.navService.push('badge');
  }

  public showGoalsPage(): void {
    this.navService.push('goals');
  }
}
